import { render, staticRenderFns } from "./correctionModal.vue?vue&type=template&id=4823cbb6"
import script from "./correctionModal.vue?vue&type=script&lang=js"
export * from "./correctionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports